export const productsData = {
  // MUJI水漾潤澤化妝水
  4550583451141: {
    name: 'MUJI水漾潤澤化妝水',
    number: '4550583451141',
    price: '590',
    img: {
      white_bg: '4550583451141_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '添加米糠發酵液與 11 種植物精華、 維他命C 誘導體、視黃醇( A醇) 誘導體作為保濕成分。能為容易乾燥的肌膚補充水分，使肌膚呈現飽滿有彈性的狀態。',
    cartUrl: 'javascript:;',
  },
  // MUJI水漾潤澤化妝水.攜帶型
  4550583483319: {
    name: 'MUJI水漾潤澤化妝水',
    number: '4550583483319',
    price: '150',
    img: {
      white_bg: '4550583483319_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '添加米糠發酵液與 11 種植物精華、 維他命C 誘導體、視黃醇( A醇) 誘導體作為保濕成分。能為容易乾燥的肌膚補充水分，使肌膚呈現飽滿有彈性的狀態。',
    cartUrl: 'javascript:;',
  },
  // MUJI水漾潤澤乳液
  4550583451158: {
    name: 'MUJI水漾潤澤乳液',
    number: '4550583451158',
    price: '590',
    img: {
      white_bg: '4550583451158_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '添加米糠發酵液與 11 種植物精華、 維他命C 誘導體、 視黃醇( A醇) 誘導體作為保濕成分。能為容易乾燥的肌膚鎖住水分，滋潤乾燥的肌膚。',
    cartUrl: 'javascript:;',
  },
  // MUJI水漾潤澤乳液.攜帶型
  4550583483326: {
    name: 'MUJI水漾潤澤乳液',
    number: '4550583483326',
    price: '150',
    img: {
      white_bg: '4550583483326_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '添加米糠發酵液與 11 種植物精華、 維他命C 誘導體、 視黃醇( A醇) 誘導體作為保濕成分。能為容易乾燥的肌膚鎖住水分，滋潤乾燥的肌膚。',
    cartUrl: 'javascript:;',
  },
  // MUJI水漾潤澤乳霜
  4550583451165: {
    name: 'MUJI水漾潤澤乳霜',
    number: '4550583451165',
    price: '590',
    img: {
      white_bg: '4550583451165_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '添加米糠發酵液與 11 種植物精華、 維他命C 誘導體、視黃醇( A醇) 誘導體作為保濕成分。幫助鎖水，給予肌膚所需油分，滋潤乾燥的肌膚。',
    cartUrl: 'javascript:;',
  },
  // MUJI水漾潤澤ALL IN ONE美容面霜
  4550583451189: {
    name: 'MUJI水漾潤澤ALL IN ONE美容面霜',
    number: '4550583451189',
    price: '590',
    img: {
      white_bg: '4550583451189_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '一瓶即具備化妝水、乳液、精華液等多重功效的保濕面霜，洗臉後只需要一個步驟就能完成基礎保養。',
    cartUrl: 'javascript:;',
  },
  // MUJI水漾潤澤ALL IN ONE美容面霜.攜帶型
  4550583451172: {
    name: 'MUJI水漾潤澤ALL IN ONE美容面霜',
    number: '4550583451172',
    price: '150',
    img: {
      white_bg: '4550583451172_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '結合化妝水、乳液、精華液等功能的面霜，呈現乳膏狀質地，讓洗臉後的保養更加簡單，適合忙碌早晨的省時保養。',
    cartUrl: 'javascript:;',
  },
};

export const lineupProductsData = [
  {
    id: 1,
    category: '化妝水・乳液',
    products: [
      {
        id: 1,
        item: '4550583451141',
        spec: [
          {
            title: '肌膚滲透性',
            level: '3',
          },
          {
            title: '保濕力',
            level: '5',
          },
        ],
        tabs: [
          {
            text: '300mL',
            number: '4550583451141',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483319',
            active: false,
          },
        ],
      },
      {
        id: 2,
        item: '4550583451158',
        spec: [
          {
            title: '肌膚滲透性',
            level: '3',
          },
          {
            title: '保濕力',
            level: '5',
          },
        ],
        tabs: [
          {
            text: '200mL',
            number: '4550583451158',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483326',
            active: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    category: '乳霜',
    products: [
      {
        id: 1,
        item: '4550583451165',
        spec: [
          {
            title: '肌膚滲透性',
            level: '4',
          },
          {
            title: '保濕力',
            level: '5',
          },
        ],
        tabs: [
          {
            text: '45g',
            number: '4550583451165',
            active: true,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    category: 'ALL IN ONE',
    products: [
      {
        id: 1,
        direction: '',
        item: '4550583451189',
        spec: [
          {
            title: '肌膚滲透性',
            level: '3',
          },
          {
            title: '保濕力',
            level: '5',
          },
        ],
        tabs: [
          {
            text: '150g',
            number: '4550583451189',
            active: true,
          },
          {
            text: '30g',
            number: '4550583451172',
            active: false,
          },
        ],
      },
    ],
  },
];

export const reportData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/feature/25ss/sensitiveskin/',
    img: 'special01.jpg',
    text: '敏感肌臉部保養系列',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/feature/25ss/clearcare/',
    img: 'special02.jpg',
    text: '清新臉部保養系列',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/24ss/ricebran/',
    img: 'special03.jpg',
    text: '米糠發酵臉部保養系列',
  },
  {
    id: 4,
    link: 'https://www.muji.tw/tw/feature/fragrance/',
    img: 'special04.jpg',
    text: '香氣・空間香氛',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/25ss/fragrant-tw/',
    img: 'special05.jpg',
    text: '台灣精油',
  },
];
